module.exports = __webpack_public_path__ + "img/logotype (1).d6dcfe0b.svg";